<template>
    <div>
        <vue-ueditor-wrap v-model="msg" :config="myConfig"></vue-ueditor-wrap>
    </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
    components: {
        VueUeditorWrap,
    },
    
    data () {
        return {
            //新闻编辑器
            msg: '',
            myConfig: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: true,
                // 初始容器宽度
                initialFrameWidth: 960,
                // 初始容器高度
                initialFrameHeight: 300,
                // UEDITOR_HOME_URL: '/uploadnews/public/UEditor/',
                UEDITOR_HOME_URL: 'UEditor/',
                // 上传文件接口
                // serverUrl: 'http://35.201.165.105:8000/controller.php',
                // serverUrl: 'http://192.168.0.8:8080/CalawaEnServlet/ueditor/jsp/controller.jsp'
                serverUrl: this.$store.state.WebURL+'/ueditor/php/controller.php'
                // serverUrl: 'http://www.templeofgood.com:8080/CalawaEnServlet/ueditor/jsp/controller.jsp'
                // serverUrl: 'http://www.templeofgood.com/controller.jsp'
                // serverUrl: 'http://localhost:8080/CalawaEnServlet/ueditor/jsp/controller.jsp'
            },
        }
    },
    watch: {
        msg:function(){
            this.$store.commit('setEditorContent', this.msg)
        },
    }
}
</script>

<style lang="scss" scoped>

</style>